import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CountersCard from '../../../../ui/CountersCard';
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import {
  counterSkillsQuery,
  counterSpecialitiesQuery
} from "./reducer";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Справочник компетенций и ФГОС",
    link: "#"
  }
];

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const DictCompetFGOSIndex = ({
                               history,
                               counterSkills,
                               counterSpecialities,
                               counterSkillsQuery,
                               counterSpecialitiesQuery
                             }) => {

  const classes = useStyles();

  const handleClick = (link) => {
    history.push(link);
  };

  useEffect(() => {
    counterSkillsQuery();
  }, [counterSkillsQuery]);

  useEffect(() => {
    counterSpecialitiesQuery();
  }, [counterSpecialitiesQuery]);


  return (
    <div>
      <Breadcrumbs items={items}/>
      <div className={classes.root}>
        <Grid container spacing={0} justify="flex-start" alignItems="flex-start">
          {counterSkills  && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterSkills}
              onClick={handleClick}
              goTo={'/work/app/dict/skills/skill'}
            />
          </Grid>}
          {counterSpecialities && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterSpecialities}
              onClick={handleClick}
              goTo={'/work/app/dict/skills/speciality'}
            />
          </Grid>}
        </Grid>
      </div>
    </div>
  )
};

const mapStateToProps = state => ({
  counterSkills: state.manageOOPResourcesFGOSIndex.counterSkills,
  counterSpecialities: state.manageOOPResourcesFGOSIndex.counterSpecialities
});

const mapDispatchToProps = dispatch => ({
  counterSkillsQuery: () => dispatch(counterSkillsQuery()),
  counterSpecialitiesQuery: () => dispatch(counterSpecialitiesQuery())
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DictCompetFGOSIndex));
